import React from "react";
// @mui
import { Stack, Typography, useTheme } from "@mui/material";

// styled components
import { ImageContainer, ImageContainer2, RootStyle, DataContainer } from "./styles";
import useResponsive from "hooks/useResponsive";

function HeroSection({ id }) {
  const theme = useTheme();
  const mdDown = useResponsive("down", "md");
  return (
    <RootStyle id={id}>
      <DataContainer>
        <Typography
          variant={mdDown ? "h3" : "h1"}
          textAlign="center"
          fontWeight="700"
          fontFamily='"Merriweather", serif'
        >
          Experience peace of mind with NBT's comprehensive transportation solutions.
        </Typography>
        <Typography variant="body1" textAlign="center" mt={2} mx={4}>
          From prioritizing safety and comfort to unparalleled training programs and proactive
          maintenance, our services embody reliability, expertise, and a commitment to excellence.
        </Typography>
      </DataContainer>
      <ImageContainer />
      <ImageContainer2 />
    </RootStyle>
  );
}

export default HeroSection;
